import { typeOf } from 'mathjs';
import { makeCommonDataSource } from '../../../../../domain/factories';

const BASE_URL = process.env.API_URL_INDO_REGION;

export enum RegionEnum {
  countries = 'countries',
  country = 'country',
  provinces = 'provinces',
  province = 'province',
  cities = 'cities',
  city = 'city',
  districts = 'districts',
  district = 'district',
  villages = 'villages',
  village = 'village',
}

export const ApiUrlData = {
  countries: 'countries',
  country: 'country',
  provinces: 'provinces',
  province: 'province',
  cities: 'cities',
  city: 'city',
  districts: 'districts',
  district: 'district',
  villages: 'villages',
  village: 'village',
};

export const defaultAdditional = {
  page: 1,
  limit: 10,
};

export function makeOptions(options) {
  const newOptions = options ?? [];
  return newOptions.map(item => {
    const keys = Object.keys(item ?? {});
    if (keys.length === 2 && keys.includes('label') && keys.includes('value'))
      return item;
    else
      return {
        label: item?.name,
        value: item,
      };
  });
}

export function filterOptions(options: any[], initialValue: any): any[] {
  let newOpt = options;
  if (Array.isArray(initialValue)) {
    newOpt = newOpt
      ?.map(item => {
        const findLabel = initialValue?.find(
          itemInit => itemInit.label === item.label
        );
        if (findLabel) return null;
        return item;
      })
      .filter(Boolean);
  }
  return newOpt;
}

export function isObject(value) {
  const exType = ['string', 'number', 'boolean'];
  const typeValue = typeOf(value);
  return !exType.includes(typeValue);
}

export function makeArrayValue(
  value: any[],
  customLabel: any,
  keyLabel: string
): any[] {
  if (!value || value?.length === 0) return value;
  return value.map(itemValue => {
    const isObj = isObject(itemValue);
    if (!isObj) {
      return {
        label: customLabel ? customLabel(itemValue) : itemValue,
        value: itemValue,
      };
    }
    return {
      label: customLabel ? customLabel(itemValue) : itemValue[keyLabel],
      value: itemValue,
    };
  });
}

export function makeValue(value: any, customLabel: any, keyLabel: string): any {
  if (!value) return value;
  const isObj = isObject(value);
  if (!isObj) {
    return {
      label: customLabel ? customLabel(value) : value,
      value: value,
    };
  }
  return {
    label: customLabel ? customLabel(value) : value[keyLabel],
    value: value,
  };
}

export function transformValue(
  value: any,
  customLabel: any,
  keyLabel: string
): any {
  if (!value) return null;
  else if (Array.isArray(value))
    return makeArrayValue(value, customLabel, keyLabel);
  return makeValue(value, customLabel, keyLabel);
}
